import { combineReducers } from "redux";

//types
import { EMPTY_STATE } from "../actions/types";

//reducers
import authentication from "./authentication/authentication";
import orders from "./orders/orders";
import {
  getStoreStatusReducer,
  setStoreStatusReducer,
} from "./store/storeStatus";
import {
  getAllMenuReducer,
  bulkUploadReducer,
  updateMenuReducer,
  bulkUploadPartnerReducer,
} from "./menu/menuReduscers";
import { addSalesReducer, getSalesItemReducer } from "./sales/sales";
import { ticketReducer } from "./ticket/ticket";

const rootReducer = combineReducers({
  authentication,
  orders,
  getStoreStatusReducer,
  setStoreStatusReducer,
  getAllMenuReducer,
  bulkUploadReducer,
  updateMenuReducer,
  bulkUploadPartnerReducer,
  addSalesReducer,
  getSalesItemReducer,
  ticketReducer,
});

export default (state: any, action: any) =>
  rootReducer(action.type === EMPTY_STATE ? undefined : state, action);
